module.exports = __webpack_public_path__ + "img/garota-apresentacao.cecfd520.png";